import { api } from "@/api";
import { ApiResponseType, APP_TYPE, PLATFORM_TYPE, USED_LOCATION_TYPE } from "@/api/type";

interface postDownloadAppProps {
  downloadType: APP_TYPE;
  platformType?: PLATFORM_TYPE;
  usedLocationType: USED_LOCATION_TYPE;
}

interface PostDownloadAppRespone {
  url: string;
}
/** 앱 다운로드 API */
export const postDownloadApp = async (data: postDownloadAppProps) => {
  const res = await api.post<ApiResponseType<PostDownloadAppRespone>>(
    '/api/web/visitors/download-records/download-requests',
    data
  );
  return res.data;
};
